import React from "react";
import { Card, Row, Col, Spinner } from "react-bootstrap";
import "./dashboardcard.scss";

const DashboardCard = (props) => {
  const { title, value, children, style = {}, className = "", loading = false, iconSmall, iconLarge, testid } = props;
  return (
    <Card
      style={{ ...style, overflow: "hidden" }}
      className={`dashboardcard ${className}`}
      {...(testid ? { "data-testid": testid } : {})}
    >
      <Card.Body className="dashboardcard-body" style={{ zIndex: "1" }}>
        <div
          style={{
            zIndex: "-100",
            position: "absolute",
            right: "-2px",
            bottom: "-4px",
            opacity: "0.2"
          }}
        >
          {iconLarge}
        </div>
        <div
          style={{
            position: "relative",
            bottom: "-3px",
            left: "-2px",
            opacity: "0.87"
          }}
        >
          {iconSmall}
        </div>
        <div className="fs-7 dashboardlabel">{title}</div>
        <Row>
          {loading ? (
            <div style={{ height: "36px" }}>
              <Spinner animation="border" size="sm" />
              <span class="small">Loading...</span>
            </div>
          ) : (
            <>
              <Col xs={"auto"}>
                {value && (
                  <div className="fs-2" style={{ zIndex: "100" }}>
                    {value}
                  </div>
                )}
              </Col>
              <Col>{children && <>{children}</>}</Col>
            </>
          )}
        </Row>
      </Card.Body>
    </Card>
  );
};

export default DashboardCard;
